import React, { useEffect, useState, useRef } from 'react';
import { Page } from '../Layout/Page'
import { LicensePlate } from './LicensePlate'
import { Result } from './Result'
import { Description } from './Description'
import { Footer } from './Footer'
import { basename } from '../../utils';
import {  data4 } from './data' //withoutReqPdt, withReqPdt,
import {fetchSettings} from './functions'

export const Home = () => {
    const [licenseplate, setLicenseplate] = useState('')
    const [disabledButton, setDisabledButton] = useState(true)
    const [resultCheck, setResultCheck] = useState(null)
    const [settings, setSettings] = useState(null)
    const [showProgress, setShowProgress] = useState(false)

    let licREf = useRef(null);

    useEffect( () => {
        //console.log('licREf ', licREf)
        licREf.current.focus();
        licREf.current.click()
        fetchSettings(setSettings)
    }, [])

    useEffect( () => {
        if (licenseplate !== ''){
            setDisabledButton(false)
        }else{
            setDisabledButton(true)
        }
    }, [licenseplate])

    const onChangeLicensePlate = (e) => {
        let inputVal = e.target.value.toUpperCase();
        const dutchLicensePlateRegex = /^[A-Z\d]{1,6}$/;

        if ( dutchLicensePlateRegex.test(inputVal) || inputVal === '' ){
            setLicenseplate(inputVal)

        }
    }

    const onCheckButtonClicked = async () => {
        try{
            setShowProgress(true)
            // let result = {
            //     ok: false
            // }
            //await timeout(2000)
            // let result = await fetch(`https://balas20.desyde.nl/oppmtdsd/services/milieuzones/check_license`, { ///${basename}/services/eloket/check_lp
            let result = await fetch(`/${basename}/services/milieuzones/check_license`, { ///${basename}/services/eloket/check_lp
                method: 'POST',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body: `p_lp=${licenseplate}`,
                //credentials: 'include'
            })
            setShowProgress(false)

            if (result.ok === true){
                let json = await result.json()
                let data = licenseplate === '000000' ? data4 : json//json.result && json.result.length > 0 ? json.result[0] : json
                if (licenseplate === '000000'){
                    console.log('substituted data ', data4)
                }

                setResultCheck(data)
            }else{
                //let {status, statusText} = result
                //alert(` code: ${status}, reason: ${statusText} `)
                // if (licenseplate === '123456'){
                //     setResultCheck(withReqPdt.result[0]) //withReqPdt withoutReqPdt
                // }else{
                //     setResultCheck(withoutReqPdt.result[0]) //withReqPdt withoutReqPdt
                // }
            }
        }catch(e){
            console.log('catch error', e)
            setShowProgress(false)
            alert('Internal error')
        }
    }

    const onClearButtonClicked = () => {
        setResultCheck(null)
        setLicenseplate('')
        //licREf.current.focus();
        setTimeout( () => {
            licREf.current.focus();
        }, 200)

    }

    return (
        <Page showProgress={showProgress}>
            <div className="home">
                <Description />

                <div className="main-content">
                    <LicensePlate
                        licenseplate={licenseplate}
                        resultCheck={resultCheck}
                        onChangeLicensePlate = {onChangeLicensePlate}
                        disabledButton={disabledButton}
                        onCheckButtonClicked={onCheckButtonClicked}
                        ref = {licREf}
                    />

                    {resultCheck !== null &&
                        <Result resultCheck={resultCheck} />
                    }
                </div>

                <Footer
                    licenseplate={licenseplate}
                    resultCheck={resultCheck}
                    disabledButton={disabledButton}
                    onCheckButtonClicked={onCheckButtonClicked}
                    onClearButtonClicked={onClearButtonClicked}
                    settings={settings}
                />

            </div>
        </Page>
    );
}
